import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

const Link = withRouter(({ to, className, children, history, onClick, ...props }) => <a
  href={to}
  rel="noopener noreferrer"
  className={className}
  onClick={(e) => {
    if (e.button == 1 || e.ctrlKey || e.metaKey) {
      return;
    }

    if (to.indexOf('//') !== -1 && to.indexOf(process.env.REACT_APP_DOMAIN) === -1) {
      return;
    }

    if (onClick && onClick(e)) {
      return;
    }

    e.preventDefault();

    history.push(to);
  }}
  {...props}
>
  {children}
</a>);

Link.propTypes = {
  to: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};

export default Link;
